import { render } from "./InfoRecarga.vue?vue&type=template&id=a96ed89e"
import script from "./InfoRecarga.vue?vue&type=script&lang=js"
export * from "./InfoRecarga.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__